import React from 'react';
import { Box, BoxExtendedProps, Option, OptionKey, ShimmerBox } from '@common-fe/common-fe';

import PlanYearPicker from './PlanYearPicker';

interface Props extends BoxExtendedProps {
  onChangeValues: (value: OptionKey | null) => void;
  value?: OptionKey | null;
  children?: React.ReactNode;
  isLoading: boolean;
  options: Option[] | null;
}
const TotalSpendPickerContainer: React.FC<Props> = ({
  children,
  isLoading,
  value,
  onChangeValues,
  options,
  ...rest
}) => {
  if (isLoading || !options) {
    return (
      <Box direction="row" align="center" height={{ min: '36px' }} justify="between" {...rest}>
        {children}

        <ShimmerBox width="120px" />
      </Box>
    );
  }
  return (
    <Box direction="row" align="center" height={{ min: '36px' }} justify="between" {...rest}>
      {children}

      {value && <PlanYearPicker value={value} onChange={onChangeValues} options={options} />}
    </Box>
  );
};
export default TotalSpendPickerContainer;
